<div class="page-header-container" fxLayoutAlign="space-between center">
  <div [fxFlex]="'1 1 ' + ratioLeft" class="left-content">
    <ng-content select="[header-left-content]"></ng-content>
  </div>
  <div [fxFlex]="'1 1 ' + ratioRight" class="right-content">
    <ng-content select="[header-right-content]"></ng-content>
  </div>
</div>
